import React, { Component } from "react";
import PropTypes from "prop-types";
import Autocomplete from "react-autocomplete";
import _ from "lodash";
import api from "APP_ROOT/api";

const debounceTimeout = 400;

export default class AutoComplete extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    search: PropTypes.func.isRequired,
    format: PropTypes.func,
    renderItem: PropTypes.func,
    watch: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSelect: PropTypes.func,
    hasId: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    selectOnBlur: PropTypes.bool,
    className: PropTypes.string,
    allowUserInput: PropTypes.bool,
    forceClear: PropTypes.number
  };

  static defaultProps = {
    onSelect: () => {},
    hasId: true
  };

  constructor(props) {
    super();

    this.state = {
      value: props.value || "",
      results: [],
      selected: null,
      open: false,
      forceClear: Number(props.forceClear)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value || "" });
    }

    if (nextProps.watch !== this.props.watch) {
      this.setState({ results: [], value: "" });
    }

    if (
      nextProps.forceClear !== undefined &&
      Number(nextProps.forceClear) !== Number(this.state.forceClear)
    ) {
      this.setState({ value: "", forceClear: Number(nextProps.forceClear) });
    }
  }

  onClick = e => {
    if (e.target === e.currentTarget) {
      this.updateResults("");
    }
  };

  onKeyUp = e => {
    const { value, results } = this.state;
    const isEnterKey = e.keyCode === 13;

    this.setState({ enter: isEnterKey });

    if (!isEnterKey) {
      return;
    }

    if (results.length === 1 && this.waitingFor === value) {
      this.select(value, results[0]);
      return;
    }

    const exactMatch = results.find(result => result.part_number === value);

    if (exactMatch) {
      this.select(value, exactMatch);
    }
  };

  updateResults = _.debounce(value => {
    this.setState({ results: [], open: false });
    // Guard clause: handle case when value is empty or null
    if (!value) {
      this.waitingFor = "";
      api.session.parts().then(({ data }) => {
        if (value === this.waitingFor) {
          this.setState({ results: data.results, open: true, value: "" });
        }
      });
      return;
    }

    this.waitingFor = value;

    this.props.search(value).then(results => {
      // Guard clause: ensure that the search result corresponds to the current value
      if (value !== this.waitingFor) {
        return;
      }
      // Check if enter was pressed
      if (this.state.enter) {
        // If there is a single result, select it
        if (results.length === 1) {
          this.select(value, results[0]);
          return;
        }
        // Check for an exact match
        const exactMatch = results.find(result => result.part_number === value);
        if (exactMatch) {
          this.select(value, exactMatch);
          return;
        }
      }
      // Default: update results
      this.setState({ results, open: true });
    });
  }, debounceTimeout);

  clearIfValueNotSelected = () => {
    if (!this.props.hasId && !this.props.allowUserInput) {
      this.setState({
        value: ""
      });
    }
    if (this.props.allowUserInput && !this.state.selected) {
      this.props.onSelect(this.state.value);
    }
  };

  select = (value, result) => {
    const { onSelect } = this.props;

    this.setState({
      selected: result,
      value: value || "",
      results: [],
      open: false
    });

    onSelect(result);
  };

  refresh = (e, value) => {
    const { onSelect } = this.props;

    this.setState({ value: value || "", selected: null });
    onSelect(null, value);
    this.updateResults(value);
  };

  renderMenu = items => <ul className="dropdown" children={items} />;

  renderItem = (item, isHighlighted) => (
    <li key={item.id} className={isHighlighted ? "selected" : ""}>
      {this.props.format(item)}
    </li>
  );

  render() {
    const {
      autoFocus,
      renderItem,
      placeholder,
      disabled = false,
      className = "autocomplete",
      selectOnBlur = true
    } = this.props;

    return (
      <Autocomplete
        value={this.state.value}
        items={this.state.results}
        getItemValue={this.props.format}
        onSelect={this.select}
        onChange={this.refresh}
        renderMenu={this.renderMenu}
        renderItem={renderItem || this.renderItem}
        wrapperStyle={{}}
        wrapperProps={{ className }}
        autoHighlight
        selectOnBlur={selectOnBlur}
        inputProps={{
          autoFocus,
          className: "form-control",
          placeholder,
          onBlur: this.clearIfValueNotSelected,
          onClick: this.onClick,
          onKeyUp: this.onKeyUp,
          selectOnBlur,
          disabled
        }}
        renderInput={inputProps => (
          <input {...inputProps} autoComplete="new-password" />
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/Nav/GlobalSearch/AutoComplete.jsx